import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Chip from "../../ui/Chip/Chip";
import Switcher from "../../ui/Switcher/Switcher";
import Button from "../../ui/Button/Button";
import { ClipboardIcon } from "../../assets/icons/ClipboardIcon";
import styles from "./ActiveWidgetContainer.module.scss";
import {
  setUpdateWidget,
  setUpdateWidgetData,
} from "../../store/slices/widgetSlice";
import Input from "../../ui/Input/Input";
import {
  updateWidgetDomains,
  updateWidgetStatus,
} from "../../utils/api/actions/widget";
import ScreenHeader from "../ScreenHeader/ScreenHeader";

export const ActiveWidgetContainer = () => {
  const dispatch = useDispatch();

  const { dataAssistants } = useSelector((state) => state?.assistant);
  const { activeWidget, updateWidget, updateWidgetData } = useSelector(
    (state) => state?.widget
  );

  const isEmptyObject = (obj) => Object.keys(obj).length > 0;

  const widgetBlocked = activeWidget?.blocked;
  const widgetActive = activeWidget?.active;
  const widgetCode = activeWidget.code;

  const assistantName =
    dataAssistants?.find(
      (assistant) => assistant.id === activeWidget?.assistantId
    )?.name || "Ассистент не найден";

  const [isSwitchOn, setIsSwitchOn] = useState(widgetActive);
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(false);

  const initialData = {
    widgetId: activeWidget.id,
    allowedDomains: activeWidget.allowedDomains,
  };

  const handleToggle = () => {
    const newStatus = !isSwitchOn;
    const data = {
      widgetId: activeWidget.id,
      active: isSwitchOn,
    };
    setIsSwitchOn(newStatus);
    dispatch(updateWidgetStatus(data));
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(activeWidget.code).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Сообщение о копировании исчезает через 2 секунды
    });
  };

  const handleFocusInput = () => {
    dispatch(setUpdateWidget(true));
  };

  const handlerInput = (e) => {
    if (updateWidget) {
      let res = JSON.parse(JSON.stringify(updateWidgetData));

      Object.defineProperty(res, e.target.name, {
        value: e.target.value,
        writable: true,
        enumerable: true,
        configurable: true,
      });

      res.widgetId = activeWidget?.id;

      dispatch(setUpdateWidgetData(res));
    }
  };

  const handleCancelEdit = () => {
    dispatch(setUpdateWidgetData(initialData));
    dispatch(setUpdateWidget(false));
  };

  const handleSaveUpdatedData = () => {
    dispatch(updateWidgetDomains(updateWidgetData, setLoading));
  };

  return (
    <div className={styles.widgetPage}>
      <ScreenHeader
        onCancelEdit={handleCancelEdit}
        onSaveUpdatedData={handleSaveUpdatedData}
        isEditing={updateWidget}
        title={"Интеграции"}
        path={"/integration"}
        loading={loading}
      />
      <div className={styles.widgetPageContainer}>
        <div className={styles.headerWidget}>
          <div className={styles.titleContainer}>
            <div className={styles.inputContainer}>
              <Input
                className={styles.child}
                label="Название"
                labelStyle={styles.labelInput}
                backgroundStyle={styles.labelBackground}
                inputStyle={styles.input}
                name="name"
                value={activeWidget ? activeWidget.name : ""}
                readOnly={true}
                type={"text"}
              />
            </div>
            <div className={styles.inputContainer}>
              <Input
                className={styles.child}
                label="Ассистент"
                labelStyle={styles.labelInput}
                backgroundStyle={styles.labelBackground}
                inputStyle={styles.input}
                name="assistant"
                value={activeWidget ? assistantName : ""}
                readOnly={true}
                type={"text"}
              />
            </div>
            <div className={styles.inputContainer}>
              <Input
                className={styles.child}
                label="Доверенные домены"
                labelStyle={styles.labelInput}
                backgroundStyle={styles.labelBackground}
                inputStyle={styles.input}
                name="allowedDomains"
                onFocus={handleFocusInput}
                value={
                  isEmptyObject(updateWidgetData)
                    ? updateWidgetData.allowedDomains
                    : activeWidget
                    ? activeWidget.allowedDomains
                    : ""
                }
                onChange={handlerInput}
                type={"text"}
              />
            </div>
          </div>

          <div className={styles.statusContainer}>
            <Chip
              classNameChip={styles.widgetChipContainer}
              active={widgetActive}
              classNameChipActive={styles.widgetChipContainerActive}
              classNameChipDisabled={styles.widgetChipContainerDisabled}
              title={widgetActive ? "Активен" : "Не активен"}
            />
            <Switcher bool={isSwitchOn} onToggle={handleToggle} />
            {widgetBlocked && (
              <Chip
                active={widgetBlocked}
                title={widgetBlocked ? "Заблокирован" : "Не заблокирован"}
              />
            )}
          </div>
        </div>

        {activeWidget.code ? (
          <div className={styles["code-block"]}>
            <div className={styles.buttonContainer}>
              <Button
                leftIcon={
                  <ClipboardIcon width={16} height={20} fill={"white"} />
                }
                onClick={handleCopy}
                titleClassName={styles.copyButtonTitle}
                className={`${styles["copy-button"]} ${
                  copied ? styles.copied : ""
                }`}
                title={copied ? "Код скопирован!" : "Скопировать код"}
              />
            </div>

            <pre>{widgetCode}</pre>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};
